import type { ComponentProps } from 'react';
import { LordIcon } from '@/shared/components/ui/lord-icon';

export type BottomTabProp = ComponentProps<'button'> & {
  title: string;
  icon: string;
};

export function BottomTabItem({ icon: Icon, title, ...props }: BottomTabProp) {
  return (
    <button className="flex flex-col items-center justify-center space-y-2.5 h-16 py-2" {...props}>
      <LordIcon src={Icon} trigger="click" />
      <span className="text-xs text-night">{title}</span>
    </button>
  );
}
